export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 4_03.f5db01d2.jpg";